import { Tooth } from '@libs/ui-lib';
import { ToothTypeEnum } from '@ffd/api-client';

export const mockTeethData: Tooth[] = [
  {
    position: 1,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 2,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 3,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 4,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 5,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 6,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 7,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 8,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 6, central: 5, mesial: 4 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 4, central: 6, mesial: 3 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 9,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 4, central: 3, mesial: 2 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 10,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 11,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 12,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 13,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 14,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 15,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 16,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'upper',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 17,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 18,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 19,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 20,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 21,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 22,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 23,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 4, central: 6, mesial: 5 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 4, central: 6, mesial: 4 },
        bleedingOnProbing: { distal: true, central: true, mesial: true },
        suppuration: { distal: true, central: true, mesial: true },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 24,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 25,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 26,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 27,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 28,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 29,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 30,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 31,

    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
  {
    position: 32,
    type: ToothTypeEnum.PERMANENT,
    perio: {
      buccal: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
      lingual: {
        pocketDepth: { distal: 0, central: 0, mesial: 0 },
        bleedingOnProbing: { distal: false, central: false, mesial: false },
        suppuration: { distal: false, central: false, mesial: false },
        clinicalAttachmentLoss: { distal: 0, central: 0, mesial: 0 },
        furcation: { distal: 0, central: 0, mesial: 0 },
        gingivalMargin: { distal: 0, central: 0, mesial: 0 },
      },
    },
    jaw: 'lower',
    boneLoss: 0,
    mobility: 0,
  },
];
